import React from 'react';
import { useAuth } from '../auth/AuthProvider';
import { ensurePostLoginRedirect } from '../auth/redirect';

export const LoginPage: React.FC = () => {
  const { initialized, authenticated, login } = useAuth();

  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
      <div>
        <h1>Sign in</h1>
        <p>You must sign in to continue.</p>
        <button
          onClick={() => {
            ensurePostLoginRedirect('/');
            void login({ redirectUri: `${window.location.origin}/callback` });
          }}
          disabled={!initialized || authenticated}
        >
          Sign in
        </button>
      </div>
    </div>
  );
};


